<template>
  <v-select
      :label="label"
      :placeholder="placeholder"
      :value="value"
      :items="items"
      item-text="label"
      dense
      :multiple="multiple"
      hide-details
      :style="{width: width, maxWidth: width}"
      :clearable="clearable"
      @change="handleChange"
  />
</template>

<script>
export default {
  name: "SimpleSelectField",
  props: {
    value: {
      type: [String, Number, Array]
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    items: {
      type: Array
    },
    width: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>
>>> .v-select__selection--comma {
  white-space: normal;
}
/*TODO: セレクトされた値が長い場合、折り返し後変に下にmarginの用になってしまう問題を解決したい*/
/*>>> .v-select__selections > input {*/
/*  display: none !important;*/
/*}*/
</style>